var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcavator(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cluster_excavator",
    width: "192.9%",
    height: "227.3%",
    x: "-46.4%",
    y: "-59.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd",
    filter: "url(#cluster_excavator)",
    transform: "matrix(-1 0 0 1 16 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.651 5.5h8.542c.295 0 .534.245.534.548v1.039a.541.541 0 0 1-.534.548H4.651a.541.541 0 0 1-.533-.548V6.048c0-.303.238-.548.533-.548z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M9.694 1.692h2.784c.295 0 .534.246.534.549v4.438a.541.541 0 0 1-.534.548H7.534A.541.541 0 0 1 7 6.68V4.46c0-1.529 1.206-2.768 2.694-2.768zm-1.87 3.19h2.241V2.599c-.72-.08-1.293.093-1.716.519-.423.426-.598 1.014-.525 1.764zm2.882-2.283V4.87h1.647V3.022a.418.418 0 0 0-.412-.423h-1.235z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.648,
    d: "M5.386 8.53c-.627 0-1.135.522-1.135 1.167 0 .644.508 1.166 1.135 1.166h7.072c.627 0 1.136-.522 1.136-1.166 0-.645-.509-1.167-1.136-1.167H5.386zm.346 2.24c-.603-.002-1.09-.506-1.089-1.126a1.138 1.138 0 0 1 .318-.794c.204-.212.481-.33.771-.332.29.001.567.12.772.331.204.212.318.497.317.795.002.62-.486 1.124-1.089 1.125zm3.294 0c-.603-.002-1.09-.506-1.089-1.126a1.138 1.138 0 0 1 .318-.794c.204-.212.481-.33.771-.332.29.001.568.12.772.331.204.212.318.497.317.795.002.62-.486 1.124-1.089 1.125zm2.965 0c-.603-.002-1.09-.506-1.09-1.126a1.138 1.138 0 0 1 .318-.794c.205-.212.482-.33.772-.332.29.001.567.12.771.331.205.212.319.497.318.795.002.62-.486 1.124-1.089 1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.558.538a.407.407 0 0 1 .507.28l1.367 4.9a.419.419 0 0 1-.285.513.407.407 0 0 1-.506-.28l-1.367-4.9a.419.419 0 0 1 .284-.513z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.072.625a.423.423 0 0 1-.146.569l-2.86 1.715a.392.392 0 0 1-.305.043.403.403 0 0 1-.245-.193.423.423 0 0 1 .147-.568L4.522.476a.392.392 0 0 1 .305-.043.403.403 0 0 1 .245.192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.486 2.285C.367 3.008.014 3.869.427 4.866c.413.997 1.327 1.303 2.742.917l-.276-.57-.352.02-.807-3.05-.248.102z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcavator);
export default __webpack_public_path__ + "static/media/excavator.9869eb35bce957cc54cbde7466ae0e6e.svg";
export { ForwardRef as ReactComponent };